import { pick, values } from 'ramda';
import { fetchy } from '@bridebook/web/lib/fetchy';
import {
  getArticleTags,
  getExtraArticleTags,
} from '@bridebook/web/lib/articles/constants/articleTags';

/**
 * get tag name of specified article tag by slug
 */
export const getTagName = (slug: string): string => {
  let name = '';

  if (slug) {
    const tag = Object.values(getArticleTags()).find((tag) => tag.value === slug);

    if (tag) {
      name = tag.label;
    } else {
      const extraTags = getExtraArticleTags();

      if (extraTags[slug]) {
        name = extraTags[slug];
      }
    }
  }

  return name;
};

/**
 * utility for fetching task data from API
 */
export const fetchRelatedTaskDataPromise = (taskId: string) =>
  fetchy().authenticated.post('/api/articles/article-related-tasks', null, {
    query: { taskId },
  });

/**
 * gets article related checklist task data
 */
export const fetchRelatedTaskData = (checklistTaskId: string) =>
  checklistTaskId ? fetchRelatedTaskDataPromise(checklistTaskId) : null;

/**
 * @param {boolean} onlyLiteTags - get only lite version tags
 */
export const getArticleTagsList = (onlyLiteTags?: boolean) => {
  const articleTags = getArticleTags();
  const tagsObj = onlyLiteTags ? pick(['all'], articleTags) : articleTags;

  return values(tagsObj);
};

export const checkIfRelative = (url: string, host: string): boolean =>
  url.indexOf('http') < 0 && url.indexOf(`/${host}`) < 0;
